<template>
  <zm-button data-testid="checkout-button-481" :data-url='targetUrl' size='large' class='opc-succezz__view__account' :type='type' round @click='goToBillingPage'>{{ $t('billing.success.confirmation.view_my_plan') }}
  </zm-button>
</template>
<script>
import { navigateToTargetPage } from '@/utils/modal-utils.js';
import { getEmailCTAsTrackingUrl, UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';

export default {
  props: {
    type: {
      type: String,
      default: 'primary',
    },
  },
  data() {
    return {
      targetUrl: getEmailCTAsTrackingUrl('/billing', { utmContent: UTM_CONTENT_CODE.viewMyPlan }),
    }
  },
  methods: {
    goToBillingPage() {
      this.$tracking.buyInteraction('purchase confirmation', 'view my plan');
      navigateToTargetPage('/billing');
    },
  },
};
</script>

<style lang='scss'>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/_variables.scss';

.opc-succezz__view__account {
  &.zm-button--plain:not(.is-ghost) {
    border: 1px solid #0C5CFF;

    .zm-button__slot {
      color: #0C5CFF;
    }
  }
}

.opc-modal {
  .opc-succezz__view__account {
    &.zm-button.zm-button--large.zm-button--plain.is-round {
      display: block;
      width: auto;
      padding: 8px 24px;
      border-radius: 12px;
      margin: 12px auto 0px;
      line-height: 22px;
    }
  }
}
</style>
